/**
 * @param path starting with the direct folder
 */
export const getRelativePath = (path = '') => {
	const { NODE_ENV } = process.env;
	if (NODE_ENV !== 'development') {
		const { REACT_APP_PUBLIC_URL = '' } = process.env;
		return `${REACT_APP_PUBLIC_URL}static/${path}`;
	}
	return `/static/${path}`;
};

export default getRelativePath;
